import type { Entity as WorkbookEntity } from '@mathflat/domain/@entities/(Content)/Workbook/dto'
import { runInAction } from 'mobx'

import { workbookController } from '@/controller/workbook.controller'
import commonRepo from '@/repository/common.repo'
import { RouteName } from '@/router'

const { replace } = commonRepo.router

class CommonWorkbookService {
  // 검정 텍스트를 노출시킬 북코드
  inspect_bookCode: number[] = []

  // async moveEditWorkbook<FixOption extends 'COPY' | 'EDIT'>({
  //   workbookResponse,
  //   entryContext,
  // }: {
  //   workbookResponse: WorkbookEntity.WorkbookResponse
  //   entryContext: MakeLessonMaterialCommonParams<FixOption>['entryContext']
  // }) {
  //   const workbook = workbookResponse.workbook
  //   const {
  //     filter: _filter,
  //     problemIdList,
  //     title,
  //     headtitle,
  //     subtitle,
  //     coverType,
  //     partitionType,
  //     schoolType,
  //     semester,
  //     grade,
  //     revision,
  //     includeAnswerRate,
  //     includeConceptName,
  //     includeLevel,
  //     includeTagTop,
  //   } = await _workbookController.fetchWorkbookDetailInfo(workbook.id)

  //   const schoolSubjectGrade = new SchoolSubjectGrade({ schoolType, semester, grade, revision })
  //   const { autoScored, ...filter } = _filter
  //   let filterId = ''

  //   switch (filter.filterType) {
  //     case 'CONCEPT': {
  //       const { filterType, workbookId, ...restFilter } = filter
  //       filterId = await _workbookController.단원유형필터.makeFilterByConcept({
  //         filterId: null,
  //         makingUnit: filter.makingUnit!,
  //         size: problemIdList.length,
  //         problemIdList,
  //         ...restFilter,
  //         onlyAutoScorable: autoScored,
  //       })
  //       break
  //     }
  //     case 'CORNER': {
  //       const { filterType, workbookId, makingUnit, corners, ...restFilter } = filter
  //       filterId = await _workbookController.단원유형필터.makeFilterByCorner({
  //         filterId: null,
  //         corners: corners as _교재필터.단원유형별필터<'학습단계추가'>['corners'],
  //         size: problemIdList.length,
  //         problemIdList,
  //         ...restFilter,
  //         onlyAutoScorable: autoScored,
  //       })
  //       break
  //     }
  //     case 'CONCEPT_BY_WORKBOOK': {
  //       const { baseWorkbookId, baseWorkbookProblemIds, filterType, ...restFilter } = filter
  //       filterId = await _workbookController.지원교재필터.makeFilterByConceptWorkbook({
  //         ...restFilter,
  //         limitProblemCountPerConcept: null, // TODO: API 수정 후 확인
  //         makingUnit: 'MIDDLE_CHAPTER', // TODO: API 수정 후 확인
  //         workbookId: baseWorkbookId,
  //         exampleProblemIds: [],
  //         workbookProblemIdList: baseWorkbookProblemIds,
  //         onlyAutoScorable: autoScored,
  //       })
  //       break
  //     }
  //     case 'CORNER_BY_WORKBOOK': {
  //       const { baseWorkbookId, baseWorkbookProblemIds, filterType, ...restFilter } = filter
  //       filterId = await _workbookController.지원교재필터.makeFilterByCornerWorkbook({
  //         ...restFilter,
  //         workbookId: baseWorkbookId,
  //         exampleProblemIds: [],
  //         workbookProblemIdList: baseWorkbookProblemIds,
  //         onlyAutoScorable: autoScored,
  //       })
  //       break
  //     }
  //     case 'SCHOOL_TEST': {
  //       const {
  //         workbookId,
  //         basePaperBoxes,
  //         includePracticeTestType,
  //         problemFilterType,
  //         filterType,
  //         ...restFilter
  //       } = filter
  //       filterId = await _workbookController.학교별기출필터.makeFilterBySchoolTest({
  //         ...restFilter,
  //         onlyAutoScorable: autoScored,
  //         maxProblemCount:
  //           problemIdList.length -
  //           (restFilter.practiceTestRound ?? 0) * BySchoolTestService.모의고사_문제수,
  //         pdfOption: {
  //           includeConceptName,
  //           includeAnswerRate,
  //           includeLevel,
  //           includeTagTop,
  //         },
  //       })
  //       break
  //     }
  //   }

  //   // // 수정시에는 workbookId 필수, 복제후 생성에는 Null
  //   const { params } = new MakeLessonMaterialCommonParams<FixOption>({
  //     filterId,
  //     entryContext,
  //   })

  //   const queryString = qs.stringify({
  //     workbookId: workbookResponse.id,
  //     title,
  //     headtitle,
  //     subtitle,
  //     coverType,
  //     partitionType,
  //     gradeLabel: schoolSubjectGrade.gradeSemesterRevisionLabel,
  //     ...('designTemplateId' in workbook && {
  //       designTemplateId: workbook.designTemplateId,
  //     }),
  //   })

  //   // 교재를 만들 당시의 옵션들을 url에 추가
  //   push(`/make-workbook/edit/${params}&${queryString}`)
  // }
  onExitMakeWorkbook = (entryPath?: string) => {
    if (entryPath) {
      replace(entryPath)
      return
    } else {
      replace(RouteName.myWorksheet)
    }
  }

  checkInspectBook(bookCode: WorkbookEntity.WorkbookResponse['id']) {
    return this.inspect_bookCode.includes(bookCode)
  }

  async fetchInspectBookCode() {
    const data = await workbookController.fetchInspectWorkbookList()
    runInAction(() => {
      this.inspect_bookCode = data
    })
  }
}

export const commonWorkbookService = new CommonWorkbookService()
